import React, { useState } from "react";
import PropTypes from "prop-types";
import { Wrapper, Label, SelectField } from "./_.styled";
import { getQueryParam } from "../../util/queryParamUtils";
import { useHistory } from "react-router-dom";

const POPULATION_FILTER_ID = "population-filter-select";

const PopulationFilter = ({ options, handleChange }) => {
  const history = useHistory();
  const dropdownItems = ["All", "Pediatric", "Adult"];
  const currentDropdownIndex = dropdownItems.indexOf(
    getQueryParam(history, "populationType")
  );
  const [selectedValue, setValue] = useState(currentDropdownIndex);

  return (
    <Wrapper>
      <Label htmlFor={POPULATION_FILTER_ID}>Show:</Label>
      <SelectField
        id={POPULATION_FILTER_ID}
        data-testid="population-filter"
        name="population-filter"
        value={selectedValue.toString()}
        onChange={(event) => {
          const {
            target: { value },
          } = event;
          setValue(value);
          handleChange(+value, options[value]);
        }}
      >
        {options.map((title, index) => (
          <SelectField.Option value={index.toString()} key={index}>
            {title}
          </SelectField.Option>
        ))}
      </SelectField>
    </Wrapper>
  );
};

PopulationFilter.defaultProps = {
  handleChange: () => {},
};

PopulationFilter.prototypes = {
  options: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
};

export default PopulationFilter;
